"use strict";

exports.__esModule = true;
exports.default = void 0;

var _renderEllipse = require("./renderEllipse");

var renderCircle = function renderCircle(ctx, node) {
  var _node$props, _node$props2, _node$props3;

  var cx = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.cx;
  var cy = (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.cy;
  var r = (_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.r;
  (0, _renderEllipse.drawEllipse)(ctx, cx, cy, r, r);
};

var _default = renderCircle;
exports.default = _default;